import styled from "styled-components";

const FlexBox = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export default FlexBox;
